import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createSlots as _createSlots } from "vue"

const _hoisted_1 = { class: "max-w-2xl" }
const _hoisted_2 = { class: "font-normal flex flex-wrap gap-3" }
const _hoisted_3 = { class: "max-w-2xl" }
const _hoisted_4 = { class: "font-normal flex flex-wrap gap-3" }
const _hoisted_5 = { class: "text-black-lp-300 text-12px xxl:text-14px" }
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "font-semibold" }, " ID Konfigurable ", -1)
const _hoisted_7 = { class: "my-1 font-normal" }
const _hoisted_8 = { class: "text-black-lp-300 text-12px xxl:text-14px" }
const _hoisted_9 = /*#__PURE__*/_createVNode("div", { class: "font-semibold" }, " Nama Konfigurasi Biaya ", -1)
const _hoisted_10 = { class: "my-1 font-normal" }
const _hoisted_11 = { class: "text-black-lp-300 text-12px xxl:text-14px" }
const _hoisted_12 = /*#__PURE__*/_createVNode("div", { class: "font-semibold" }, " Deskripsi ", -1)
const _hoisted_13 = { class: "my-1 font-normal w-8/12 capitalize" }
const _hoisted_14 = { class: "text-black-lp-300 text-12px xxl:text-14px" }
const _hoisted_15 = /*#__PURE__*/_createVNode("div", { class: "font-semibold" }, " Jenis Pengiriman ", -1)
const _hoisted_16 = { class: "my-3 font-normal flex flex-wrap w-10/12 gap-3" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { class: "text-black-lp-300 text-12px xxl:text-14px" }
const _hoisted_19 = /*#__PURE__*/_createVNode("div", { class: "font-semibold" }, " Jenis Barang yang Dikecualikan ", -1)
const _hoisted_20 = { class: "my-3 font-normal flex flex-wrap w-10/12 gap-3" }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { class: "my-1 font-normal w-8/12 capitalize" }
const _hoisted_23 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_24 = /*#__PURE__*/_createVNode("div", { class: "text-xl text-black-lp-300 font-semibold" }, " Daftar Biaya Tambahan ", -1)
const _hoisted_25 = { class: "text-black-lp-300 text-12px xxl:text-14px" }
const _hoisted_26 = /*#__PURE__*/_createVNode("div", { class: "font-semibold" }, " Status Configurable Price ", -1)
const _hoisted_27 = { class: "my-1 font-normal" }
const _hoisted_28 = { class: "flex" }
const _hoisted_29 = { class: "capitalize" }
const _hoisted_30 = { class: "text-black-lp-300 text-12px xxl:text-14px" }
const _hoisted_31 = /*#__PURE__*/_createVNode("div", { class: "font-semibold" }, " Tanggal Dibuat ", -1)
const _hoisted_32 = { class: "my-1 font-normal" }
const _hoisted_33 = { class: "text-gray-lp-500" }
const _hoisted_34 = { class: "text-black-lp-300 text-12px xxl:text-14px" }
const _hoisted_35 = /*#__PURE__*/_createVNode("div", { class: "font-semibold" }, " Terakhir Diubah ", -1)
const _hoisted_36 = { class: "my-1 font-normal" }
const _hoisted_37 = { class: "text-gray-lp-500" }
const _hoisted_38 = { class: "inline-flex" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Chips = _resolveComponent("Chips")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_TableV1 = _resolveComponent("TableV1")!
  const _component_button_fill = _resolveComponent("button-fill")!
  const _component_DetailLayout = _resolveComponent("DetailLayout")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_Dialog, {
      title: "Pengecualian Commodity",
      modelValue: _ctx.modelDialog,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.modelDialog = $event))
    }, {
      default: _withCtx(() => [
        _createVNode("div", _hoisted_1, [
          _createVNode("div", _hoisted_2, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.commodityExclude, (commodity, index) => {
              return (_openBlock(), _createBlock("div", {
                class: "flex-col",
                key: index
              }, [
                _createVNode(_component_Chips, {
                  label: commodity.commodity_name
                }, null, 8, ["label"])
              ]))
            }), 128))
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_Dialog, {
      title: "Pengecualian Produk",
      modelValue: _ctx.modelDialogProduct,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.modelDialogProduct = $event))
    }, {
      default: _withCtx(() => [
        _createVNode("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.productInclude, (product, index) => {
              return (_openBlock(), _createBlock("div", {
                class: "flex-col",
                key: index
              }, [
                _createVNode(_component_Chips, { label: product }, null, 8, ["label"])
              ]))
            }), 128))
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_DetailLayout, {
      onBack: _ctx.goBack,
      loading: _ctx.isLoading,
      error: _ctx.isError,
      errorType: _ctx.errorCause,
      onTryAgain: _ctx.fetchDetail,
      title: "Heavyweight Surcharge"
    }, _createSlots({
      "sub-data": _withCtx(() => [
        _createVNode("div", _hoisted_25, [
          _hoisted_26,
          _createVNode("div", _hoisted_27, [
            _createVNode("div", _hoisted_28, [
              _createVNode("div", {
                class: 
                `rounded-full px-2 py-0 font-medium ${
                  _ctx.configurableHeavyWeight.heavy_weight_surcharge_status.toLowerCase() ===
                  'active'
                    ? 'bg-green-lp-300'
                    : 'bg-red-lp-600'
                } ${
                  _ctx.configurableHeavyWeight.heavy_weight_surcharge_status.toLowerCase() ===
                  'active'
                    ? 'text-green-lp-200'
                    : 'text-red-lp-500'
                }`
              
              }, [
                _createVNode("span", _hoisted_29, _toDisplayString(_ctx.configurableHeavyWeight.heavy_weight_surcharge_status.toLowerCase()), 1)
              ], 2)
            ])
          ])
        ]),
        _createVNode("div", _hoisted_30, [
          _hoisted_31,
          _createVNode("div", _hoisted_32, _toDisplayString(_ctx.createdAt), 1),
          _createVNode("div", _hoisted_33, _toDisplayString(_ctx.dataDetail.configurablePriceCreatedBy), 1)
        ]),
        _createVNode("div", _hoisted_34, [
          _hoisted_35,
          _createVNode("div", _hoisted_36, _toDisplayString(_ctx.updatedAt), 1),
          _createVNode("div", _hoisted_37, _toDisplayString(_ctx.dataDetail.configurablePriceUpdatedBy), 1)
        ]),
        _createVNode("div", _hoisted_38, [
          (_ctx.isEditAble)
            ? (_openBlock(), _createBlock(_component_button_fill, {
                key: 0,
                title: "Ubah",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.goEdit())),
                class: "px-8 bg-red-lp-300"
              }))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 2
    }, [
      (!_ctx.isLoading)
        ? {
            name: "data",
            fn: _withCtx(() => [
              _createVNode("div", _hoisted_5, [
                _hoisted_6,
                _createVNode("div", _hoisted_7, _toDisplayString(_ctx.dataDetail.id), 1)
              ]),
              _createVNode("div", _hoisted_8, [
                _hoisted_9,
                _createVNode("div", _hoisted_10, _toDisplayString(_ctx.dataDetail.configurablePriceName), 1)
              ]),
              _createVNode("div", _hoisted_11, [
                _hoisted_12,
                _createVNode("div", _hoisted_13, _toDisplayString(_ctx.configurableHeavyWeight.heavy_weight_surcharge_description), 1)
              ]),
              _createVNode("div", _hoisted_14, [
                _hoisted_15,
                _createVNode("div", _hoisted_16, [
                  (!_ctx.productInclude?.length)
                    ? (_openBlock(), _createBlock("div", _hoisted_17, " - "))
                    : (_openBlock(true), _createBlock(_Fragment, { key: 1 }, _renderList(_ctx.productInclude?.slice(0, 10), (product, index) => {
                        return (_openBlock(), _createBlock("div", {
                          class: "flex-col",
                          key: index
                        }, [
                          _createVNode(_component_Chips, { label: product }, null, 8, ["label"])
                        ]))
                      }), 128))
                ]),
                (_ctx.productInclude?.length > 10)
                  ? (_openBlock(), _createBlock("div", {
                      key: 0,
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.modelDialogProduct = true)),
                      class: "text-red-lp-100 font-medium cursor-pointer mb-4"
                    }, " Lihat Semua "))
                  : _createCommentVNode("", true)
              ]),
              _createVNode("div", _hoisted_18, [
                _hoisted_19,
                _createVNode("div", _hoisted_20, [
                  (_ctx.commodityExclude?.length === 0)
                    ? (_openBlock(), _createBlock("div", _hoisted_21, " - "))
                    : (_openBlock(true), _createBlock(_Fragment, { key: 1 }, _renderList(_ctx.commodityExclude?.slice(0, 10), (commodity, index) => {
                        return (_openBlock(), _createBlock("div", {
                          class: "flex-col",
                          key: index
                        }, [
                          _createVNode(_component_Chips, {
                            label: commodity.commodity_name
                          }, null, 8, ["label"])
                        ]))
                      }), 128))
                ]),
                (_ctx.commodityExclude?.length > 10)
                  ? (_openBlock(), _createBlock("div", {
                      key: 0,
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.modelDialog = true)),
                      class: "text-red-lp-100 font-medium cursor-pointer mb-4"
                    }, " Lihat Semua "))
                  : _createCommentVNode("", true)
              ]),
              _createVNode(_component_DataWrapper, { label: "Tipe Heavyweight Surcharge" }, {
                default: _withCtx(() => [
                  _createVNode("div", _hoisted_22, _toDisplayString(_ctx.dataDetail.heavyweightSurchargeType), 1)
                ]),
                _: 1
              }),
              _hoisted_23,
              _hoisted_24,
              _createVNode(_component_TableV1, {
                columns: _ctx.columns,
                data: _ctx.additionalCosts
              }, null, 8, ["columns", "data"])
            ])
          }
        : undefined
    ]), 1032, ["onBack", "loading", "error", "errorType", "onTryAgain"])
  ], 64))
}